// @flow
import client from '../../client'
import format from '../../utils/format'

// Types
export type GbtUser = {
  first_name: string,
  last_name: string,
  corp_id_list: Array<string>,
}

// Constants
export const CHECK_GBT_EMAIL_ENDPOINT =
  '/corporate/gbt/gbt-emails/check/?email={0}'

/**
 * Get TC's client data
 * @param {string} PNR the passenger name record for gbt
 * @return {Promise|Error} A resolved Promise with the client data or Rejected with an Error
 */
export const checkGbtEmail = (data: { email: string }): Promise<?GbtUser> => {
  const endpoint = format(CHECK_GBT_EMAIL_ENDPOINT, data.email)
  return client.get(endpoint).catch(() => null)
}

export default checkGbtEmail
